import React from 'react';
import styled from 'styled-components';

import { useTheme } from '@cobalt/react-theme-provider';
import Flex from '@cobalt/react-flex';
import Icon from '@cobalt/react-icon';

export enum OperateEnum {
  OK = 'OK',
  CANCEL = 'CANCEL',
}

interface OperateProps {
  dataPrefix?: string;
  visible: boolean;
  disabledCancel?: boolean;
  disabledOk?: boolean;
  onClick: (type: OperateEnum) => void;
}

const OperateContainer = styled(Flex)<{ visible: boolean }>`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: all 0.2s ease-in-out 0s;
  z-index: 999;
`;
const OperateButtonWrap = styled.div`
  width: 32px;
  height: 32px;
  background-color: var(--white);

  &:last-of-type {
    margin-left: 4px;
  }
`;
const OperateButton = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: var(--primary-200);
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
  transition: background-color 0.5s ease;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background-color: var(--primary-300);
  }
  &:active {
    background-color: var(--primary-400);
  }
  &[disabled] {
    background-color: var(--primary-200);
    opacity: 0.4;
  }
`;

function Operate(props: OperateProps) {
  const { dataPrefix, visible, disabledCancel, disabledOk, onClick } = props;

  const theme = useTheme();

  return (
    <OperateContainer visible={visible}>
      {/* Cancel button */}
      <OperateButtonWrap>
        <OperateButton
          data-bi={`${dataPrefix}-clear`}
          data-type={OperateEnum.CANCEL}
          tabIndex={-1}
          disabled={disabledCancel}
          onClick={() => onClick(OperateEnum.CANCEL)}
        >
          <Icon name="clear" size="tiny" color={theme.primary500} />
        </OperateButton>
      </OperateButtonWrap>

      {/* Save buttom */}
      <OperateButtonWrap>
        <OperateButton
          data-bi={`${dataPrefix}-done`}
          data-type={OperateEnum.OK}
          tabIndex={-1}
          disabled={disabledOk}
          onClick={() => onClick(OperateEnum.OK)}
        >
          <Icon name="done" size="tiny" color={theme.primary500} />
        </OperateButton>
      </OperateButtonWrap>
    </OperateContainer>
  );
}

export default Operate;
